{
  "AUTOMATION": {
    "HEADER": "Автоматизация",
    "DESCRIPTION": "Автоматизация может заменить и упростить существующие процессы, которые требуют ручной работы, такие как добавление меток и распределение разговоров на наиболее подходящего агента. Это позволяет команде сосредоточиться на своих сильных сторонах, сокращая время, затраченное на рутинные задачи.",
    "LEARN_MORE": "Узнайте больше об автоматизации",
    "HEADER_BTN_TXT": "Добавить правило автоматизации",
    "LOADING": "Получение правил автоматизации",
    "ADD": {
      "TITLE": "Добавить правило автоматизации",
      "SUBMIT": "Создать",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "FORM": {
        "NAME": {
          "LABEL": "Название правила",
          "PLACEHOLDER": "Введите название правила",
          "ERROR": "Необходимо указать имя"
        },
        "DESC": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Введите описание правила",
          "ERROR": "Необходимо описание"
        },
        "EVENT": {
          "LABEL": "Событие",
          "PLACEHOLDER": "Пожалуйста, выберите один",
          "ERROR": "Необходимо указать событие"
        },
        "PHASE": {
          "LABEL": "Этап"
        },
        "ORDER": {
          "LABEL": "Порядок",
          "ERROR": "Порядок обязателен"
        },
        "CONDITIONS": {
          "LABEL": "Условия"
        },
        "ACTIONS": {
          "LABEL": "Действия"
        }
      },
      "CONDITION_BUTTON_LABEL": "Добавить условие",
      "ACTION_BUTTON_LABEL": "Добавить действие",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно добавлено",
        "ERROR_MESSAGE": "Не удалось создать правило автоматизации, пожалуйста, повторите попытку позже"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Этап",
        "ORDER": "Порядок",
        "NAME": "Имя",
        "DESCRIPTION": "Описание",
        "ACTIVE": "Активно",
        "CREATED_ON": "Создано",
        "WAIT": "Ожидание"
      },
      "404": "Правила автоматизации не найдены",
      "TABS": {
        "ALL": "Все",
        "INSTANT": "При событии",
        "DELAYED": "С задержкой"
      },
      "WAITS": "Ждёт {duration}"
    },
    "DELETE": {
      "TITLE": "Удалить правило автоматизации",
      "SUBMIT": "Удалить",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы точно хотите удалить ",
        "YES": "Да, удалить ",
        "NO": "Нет, не удалять "
      },
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно удалено",
        "ERROR_MESSAGE": "Не удалось удалить правило автоматизации, пожалуйста, повторите попытку позже"
      }
    },
    "EDIT": {
      "TITLE": "Изменить правило автоматизации",
      "SUBMIT": "Обновить",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно обновлено",
        "ERROR_MESSAGE": "Не удалось обновить правило автоматизации, повторите попытку позже"
      }
    },
    "CLONE": {
      "TOOLTIP": "Копировать",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно скопировано",
        "ERROR_MESSAGE": "Не удалось скопировать правило автоматизации, повторите попытку позже"
      }
    },
    "FORM": {
      "EDIT": "Редактировать",
      "CREATE": "Создать",
      "DELETE": "Удалить",
      "CANCEL": "Отменить",
      "RESET_MESSAGE": "Изменение типа события сбросит условия и события, добавленные вами ниже"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Вам нужно иметь по крайней мере одно условие для сохранения",
      "CONTACT_CUSTOM_ATTR_LABEL": "Контактные пользовательские атрибуты",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Пользовательские атрибуты разговора"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Вам нужно иметь по крайней мере одно условие для сохранения",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Напишите здесь ваше сообщение",
      "TEAM_DROPDOWN_PLACEHOLDER": "Выберите команды",
      "EMAIL_INPUT_PLACEHOLDER": "Введите адрес электронной почты",
      "URL_INPUT_PLACEHOLDER": "Введите URL-адрес",
      "SENDER_DROPDOWN_PLACEHOLDER": "Выберите источник электронной почты и адрес отправителя",
      "SUBJECT_INPUT_PLACEHOLDER": "Тема письма",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Выберите SMS-источник, из которого отправить SMS",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Введите текст SMS",
      "SMS_COUNTER": "{length}/{limit} символов, {segments} SMS (до подстановки переменных)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Включить правило автоматизации",
      "DEACTIVATION_TITLE": "Выключить правило автоматизации",
      "ACTIVATION_DESCRIPTION": "Это действие запустит правило автоматизации '{automationName}'. Вы уверены, что хотите продолжить?",
      "DEACTIVATION_DESCRIPTION": "Это действие отключит правило автоматизации '{automationName}'. Вы уверены, что хотите продолжить?",
      "ACTIVATION_SUCCESFUL": "Правило автоматизации успешно включено",
      "DEACTIVATION_SUCCESFUL": "Правило автоматизации успешно отключено",
      "ACTIVATION_ERROR": "Не удалось включить правило автоматизации, пожалуйста, повторите попытку позже",
      "DEACTIVATION_ERROR": "Не удалось отключить правило автоматизации, пожалуйста, повторите попытку позже",
      "CONFIRMATION_LABEL": "Да",
      "CANCEL_LABEL": "Нет"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Не удалось загрузить вложение, попробуйте еще раз",
      "LABEL_IDLE": "Загрузка вложений",
      "LABEL_UPLOADING": "Загружаем...",
      "LABEL_UPLOADED": "Успешно загружено",
      "LABEL_UPLOAD_FAILED": "Загрузка не удалась"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Необходимо ввести ключ атрибута",
      "FILTER_OPERATOR_REQUIRED": "Требуется оператор фильтра",
      "VALUE_REQUIRED": "Необходимо указать значение",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Значение должно быть между 1 и 998",
      "ACTION_PARAMETERS_REQUIRED": "Требуются параметры действий",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Требуется хотя бы одно условие",
      "ATLEAST_ONE_ACTION_REQUIRED": "Требуется хотя бы одно действие"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Это действие работает только тогда, когда этап правила установлен как «До разметки».",
      "SKIP_AUTO_LABELING": "Это действие работает только тогда, когда этап правила установлен как «До разметки».",
      "MOVE_CONVERSATION_TO_INBOX": "В почтовый источник можно перемещать только email-диалоги и диалоги из веб-чата, причём веб-чат — только если у контакта есть адрес электронной почты. В остальных случаях диалог остаётся на месте, а вместо этого добавляется личная заметка.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Начинает новый диалог с контактом в выбранном источнике электронной почты, отправляет ему сообщение по электронной почте и помечает диалог как решённый. Это происходит при каждом срабатывании правила. Если у контакта нет адреса электронной почты, ничего не отправляется, а вместо этого добавляется личная заметка.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Начинает новый диалог с контактом в выбранном SMS-источнике, отправляет ему сообщение по SMS и помечает диалог как решённый. Это происходит при каждом срабатывании правила. Сообщение — обычный текст без вложений. Если у контакта нет номера телефона, ничего не отправляется, а вместо этого добавляется личная заметка."
    },
    "NOTICES": {
      "AI_PROMPT": "Каждая отдельная оценка оплачивается.",
      "INCOMING_MESSAGES_COUNT": "Это относится к количеству входящих сообщений в диалоге.",
      "OUTGOING_MESSAGES_COUNT": "Это относится к количеству исходящих сообщений в диалоге."
    },
    "PHASE": {
      "BEFORE_LABELING": "До разметки",
      "AFTER_LABELING": "После разметки"
    },
    "NONE_OPTION": "Ничего",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Входящее сообщение",
      "OUTGOING": "Исходящее сообщение",
      "PRIVATE": "Приватная заметка",
      "AI_SUMMARY": "Сводка ИИ"
    },
    "YES_NO_VALUES": {
      "YES": "Да",
      "NO": "Нет"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Личное сообщение в Instagram",
      "FACEBOOK_COMMENT": "Комментарий в Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Диалог создан",
      "CONVERSATION_UPDATED": "Диалог обновлён",
      "MESSAGE_CREATED": "Сообщение создано",
      "CONVERSATION_OPENED": "Диалог открыт",
      "CONVERSATION_RESOLVED": "Диалог решён",
      "PHONE_CALL_FINISHED": "Звонок завершён"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Назначить агента",
      "ASSIGN_TEAM": "Назначить команду",
      "ADD_LABEL": "Добавить метку",
      "REMOVE_LABEL": "Удалить метку",
      "SEND_EMAIL_TO_TEAM": "Отправить email команде",
      "SEND_EMAIL_TRANSCRIPT": "Отправить транскрипт по email",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Отправить подробный транскрипт по email",
      "MUTE_CONVERSATION": "Заглушить диалог",
      "SNOOZE_CONVERSATION": "Отложить диалог",
      "RESOLVE_CONVERSATION": "Решить диалог",
      "OPEN_CONVERSATION": "Открыть диалог",
      "SEND_WEBHOOK_EVENT": "Отправить событие вебхука",
      "SEND_ATTACHMENT": "Отправить вложение",
      "SEND_MESSAGE": "Отправить сообщение",
      "ADD_NOTE": "Добавить заметку",
      "CHANGE_PRIORITY": "Изменить приоритет",
      "ADD_SLA": "Добавить SLA",
      "SKIP_AUTO_PRIORITY": "Пропустить автоматический приоритет",
      "SKIP_AUTO_LABELING": "Пропустить автоматическую разметку",
      "AUTO_TRANSLATE": "Перевести сообщение",
      "AUTO_TRANSLATE_CONVERSATION": "Перевести диалог",
      "MOVE_CONVERSATION_TO_INBOX": "Переместить диалог в источник",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Отправить сообщение в новом диалоге",
      "SEND_SMS_IN_NEW_CONVERSATION": "Отправить SMS в новом диалоге",
      "STOP_PROCESSING_RULES": "Остановить обработку правил"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Фильтр ИИ",
      "MESSAGE_TYPE": "Тип сообщения",
      "MESSAGE_CONTAINS": "Содержимое сообщения",
      "EMAIL": "Email",
      "INBOX": "Источник",
      "CHANNEL_TYPE": "Тип источника",
      "CONVERSATION_LANGUAGE": "Язык диалога",
      "PHONE_NUMBER": "Номер телефона",
      "STATUS": "Статус",
      "BROWSER_LANGUAGE": "Язык браузера",
      "MAIL_SUBJECT": "Тема письма",
      "COUNTRY_NAME": "Страна",
      "MARKETPLACE_COUNTRY": "Страна маркетплейса",
      "REFERER_LINK": "Ссылка реферера",
      "ASSIGNEE_NAME": "Назначенный",
      "TEAM_NAME": "Команда",
      "PRIORITY": "Приоритет",
      "CALL_DIRECTION": "Направление звонка",
      "MISSED_CALL": "Пропущенный звонок",
      "MISSED_CALL_COUNT": "Количество пропущенных звонков",
      "MESSAGE_SOURCE_TYPE": "Тип источника сообщения",
      "INCOMING_MESSAGE_COUNT": "Количество входящих сообщений",
      "OUTGOING_MESSAGE_COUNT": "Количество исходящих сообщений",
      "LABEL": "Метка",
      "EMAIL_RECIPIENTS": "Получатель email",
      "EMAIL_AUTO_REPLY": "Email является автоматическим ответом",
      "ATTACHMENT_EXTENSION": "Расширение вложения",
      "EXTENSION": "Вызванный добавочный номер",
      "WORKING_HOURS": "В рабочее время",
      "AGENT_REPLIED": "Агент ответил после смены статуса"
    },
    "WAIT": {
      "RUN_LABEL": "Выполнить действия",
      "INSTANT": "При событии",
      "DELAYED": "С задержкой",
      "TRIGGER_LABEL": "Ждать, пока",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Разговор остаётся в статусе",
        "CUSTOMER_UNRESPONSIVE": "Клиент не отвечает агенту",
        "AGENT_UNRESPONSIVE": "Клиент не получает ответа агента"
      },
      "STATUS_LABEL": "Статус",
      "STATUSES": {
        "OPEN": "Открыт",
        "PENDING": "В ожидании",
        "SNOOZED": "Отложен",
        "RESOLVED": "Решён"
      },
      "DELAY_LABEL": "Время ожидания",
      "DELAY_ERROR": "Введите время ожидания от 1 минуты до 30 дней",
      "DURATION": {
        "MINUTES": "{count} мин",
        "HOURS": "{count} ч",
        "DAYS": "{count} дн"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Действия выполняются, когда разговор находится в статусе {status} в течение {duration}. Смена статуса до этого их отменяет. Метки, рабочее время и ответы агента проверяются по окончании ожидания.",
        "CUSTOMER_UNRESPONSIVE": "Действия выполняются, когда клиент {duration} не отвечает на сообщение агента. Ответ клиента их отменяет; новое сообщение агента перезапускает ожидание.",
        "AGENT_UNRESPONSIVE": "Действия выполняются, когда клиент ждёт {duration} без ответа агента. Ответ агента их отменяет."
      }
    }
  }
}
